// extracted by mini-css-extract-plugin
export default {"shiftToTop":"CommonRelationshipField_shiftToTop__Nzgm2","entityIcon":"CommonRelationshipField_entityIcon__kM7Oj"};